import React from 'react';
import { Box, Typography } from '@mui/material';
import { PageIndices } from '@/common/i-doc/i-doc.registry.ts';
import { PageCard } from '@components/common/PageCard.tsx';
import { PageHint } from '@components/common/PageHint.tsx';

// Клієнти експерта для продакт-менеджера (2026-10-10). Поки заготовка, доробляємо окремо.
export const PmExpertClientsTab: React.FC = () => (
  <Box data-i-doc={PageIndices.PM_EXPERT_CLIENTS}>
    <PageHint iDoc={PageIndices.PM_EXPERT_CLIENTS} />
    <PageCard>
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">Клієнти експерта для продакта. Розділ у розробці.</Typography>
      </Box>
    </PageCard>
  </Box>
);
